import React, { useState } from "react";
import { useLocation } from "react-router";
import queryString from "query-string";
import { useStateSelector } from "utils/field";
import { isEmpty } from "lodash";

import SectionHeading from "components/SectionHeading";
import Tabs from "components/Tabs";
import { CloseDialog } from "components/Dialog";
import Card from "components/Card";
import Basic from "./Basic";
import MiniAudit from "./MiniAudit";
import TakeoffUpload from "./TakeoffUpload";

import classes from "./style.module.scss";

export default ({ loading, history }) => {
    const [intialPath, initialTab] = window.location.pathname.split("create");
    const [tab, changeTab] = useState(initialTab);
    const { search } = useLocation();
    const { folderId } = queryString.parse(search);
    const [currentFolderId, setCurrentFolderId] = useState(folderId || null);

    const {
        isUserVerified = true,
        modelDir: { models = {} } = {},
        userPermissions: { VOLTA_DEV = false, BKC_TAKEOFF_UPLOAD = false } = {},
        email: userEmail = "",
    } = useStateSelector("user");

    const hasTakeoffUploadPermission = VOLTA_DEV || BKC_TAKEOFF_UPLOAD || userEmail.includes("@buildingknowledge.ca");

    const hasFiveModels = isUserVerified ? false : !isEmpty(models) ? Object.keys(models).length >= 5 : false;

    if (loading) {
        return "Creating Model!";
    }

    return (
        <div className={classes.create}>
            <SectionHeading
                className={classes.createHeading}
                title="Create New Model"
                subtitle="Provide some basic information about your model to get things started."
            />
            <CloseDialog closeActions={() => history.push("/dashboard")} className={classes.close} />
            <Card className={classes.card}>
                <Tabs
                    initialTab={initialTab || "/"}
                    tabActive={tab || "/"}
                    tabs={[
                        { name: "Standard", url: "/", minWidth: "10rem", className: classes.tab },
                        {
                            name: "Preliminary Assessment",
                            url: "/assessment",
                            minWidth: "10rem",
                            className: classes.tab,
                        },
                        hasTakeoffUploadPermission
                            ? {
                                  name: "Takeoff Upload",
                                  url: "/takeoff",
                                  minWidth: "10rem",
                                  className: classes.tab,
                              }
                            : {},
                    ]}
                    onChange={(e) => {
                        history.push(`/create${e}`);
                        return changeTab(e);
                    }}
                >
                    <Basic
                        history={history}
                        hasFiveModels={hasFiveModels}
                        currentFolderId={currentFolderId}
                        setCurrentFolderId={setCurrentFolderId}
                    />
                    <MiniAudit history={history} hasFiveModels={hasFiveModels} />
                    {hasTakeoffUploadPermission && (
                        <TakeoffUpload
                            history={history}
                            hasFiveModels={hasFiveModels}
                            currentFolderId={currentFolderId}
                            setCurrentFolderId={setCurrentFolderId}
                        />
                    )}
                </Tabs>
            </Card>
        </div>
    );
};
